const SHA256_HEX_PATTERN = /^[a-f0-9]{64}$/i
const E164_PHONE_PATTERN = /^\+[1-9]\d{7,14}$/
const PHONE_INPUT_PATTERN = /^[\d+\s().-]+$/

const COUNTRY_CODE_ALIASES = {
  TW: new Set(['TW', 'TWN', 'TAIWAN', '886', '+886', '台灣', '台湾']),
  JP: new Set(['JP', 'JPN', 'JAPAN', '81', '+81', '日本']),
  AU: new Set(['AU', 'AUS', 'AUSTRALIA', '61', '+61', '澳洲', '澳大利亞', '澳大利亚']),
}

function resolveCountryCode(value = '') {
  const normalizedValue = String(value || '').trim().toUpperCase()
  if (!normalizedValue)
    return ''

  return Object.entries(COUNTRY_CODE_ALIASES).find(([, aliases]) => {
    return aliases.has(normalizedValue)
  })?.[0] || ''
}

function normalizeKnownCountryPhone(digits, countryCode) {
  if (countryCode === 'TW') {
    if (/^8869\d{8}$/.test(digits))
      return `+${digits}`
    if (/^09\d{8}$/.test(digits))
      return `+886${digits.slice(1)}`
    if (/^9\d{8}$/.test(digits))
      return `+886${digits}`
    return ''
  }

  if (countryCode === 'JP') {
    if (/^81\d{9,10}$/.test(digits))
      return `+${digits}`
    if (/^0\d{9,10}$/.test(digits))
      return `+81${digits.slice(1)}`
    return ''
  }

  if (countryCode === 'AU') {
    if (/^614\d{8}$/.test(digits))
      return `+${digits}`
    if (/^04\d{8}$/.test(digits))
      return `+61${digits.slice(1)}`
    return ''
  }

  return ''
}

export function normalizeTikTokPhoneIdentifier(value, country = '') {
  const normalizedValue = String(value || '').trim()
  if (!normalizedValue)
    return ''

  if (SHA256_HEX_PATTERN.test(normalizedValue)) {
    return normalizedValue.toLowerCase()
  }

  if (!PHONE_INPUT_PATTERN.test(normalizedValue))
    return ''

  const compactValue = normalizedValue.replace(/[\s().-]/g, '')
  const explicitInternationalValue = compactValue.startsWith('00')
    ? `+${compactValue.slice(2)}`
    : compactValue

  if (explicitInternationalValue.startsWith('+')) {
    return E164_PHONE_PATTERN.test(explicitInternationalValue)
      ? explicitInternationalValue
      : ''
  }

  const countryCode = resolveCountryCode(country)
  const internationalValue = normalizeKnownCountryPhone(explicitInternationalValue, countryCode)

  return E164_PHONE_PATTERN.test(internationalValue) ? internationalValue : ''
}
